import { format } from 'date-fns/format'
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow'
import { parseISO } from 'date-fns/parseISO'
import { isValid } from 'date-fns/isValid'

let _dateLocale = null
export function setDateLocale(locale) { _dateLocale = locale }

export function getLocale() {
  return navigator?.language || 'en-GB'
}

export function fmtDate(dateStr) {
  if (!dateStr) return '—'
  const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr
  if (!isValid(d)) return '—'
  return format(d, 'dd MMM yyyy', _dateLocale ? { locale: _dateLocale } : {})
}

export function fmtDateTime(dateStr) {
  if (!dateStr) return '—'
  const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr
  if (!isValid(d)) return '—'
  return format(d, 'dd MMM yyyy HH:mm', _dateLocale ? { locale: _dateLocale } : {})
}

export function fmtRelative(dateStr) {
  if (!dateStr) return '—'
  const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr
  if (!isValid(d)) return '—'
  return formatDistanceToNow(d, { addSuffix: true, ...(_dateLocale ? { locale: _dateLocale } : {}) })
}

export function toInputDate(dateStr) {
  if (!dateStr) return ''
  const d = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr
  if (!isValid(d)) return ''
  return format(d, 'yyyy-MM-dd')
}
